/////////////////////////////////////////////////V5CommentStart
// 2021-03-16 - Big Cleanup
// 2022-12-20 - Big cleanup
//  need to rationalize lite lookup
/////////////////////////////////////////////////V5CommentEnd

const gcache = 'force-cache' // set to no-cache for testing
// const cache = 'no-cache'  // set to no-cache for testing DDFIX... should this be gcache?

//wtf is this doing
let memo = {}

//---------------------------------------
// DO NOT COUNT ON ANYTHING OTHER THAN LAT/LONG/ZIP,
// no one uses the other crap in result at the moment
// pass in zip or all 3
// avoids external lookups and maintains local copy, memo, not sure why )(*$#) kept that
// IDEALLY, we wouldnt be calling this if we had the lat/long/zip, which we now usually have
// but there are alot of calls, so this is becoming a validator more than a lookup, i hope
//---------------------------------------
export const getLocationFromZipCode = (location, cache = gcache) => {
  console.log(`CFD_FUNC_LOCA_getLocationFromZipCode 0 : ` + location)
  //wtf is the goal here pat? const zipCode = location.zipCode || ''
  const { zipCode, latitude, longitude } = location

  // *************************************
  //  Should ALWAYS have a zip
  // *************************************
  if (!zipCode) {
    Promise.reject(
      new Error('getLocationFromZipCode: missing location.zipCode')
    )
  }

  // *************************************
  //  Determine what was passed in, that has priority
  //  just return it back
  //  DDFIX - when does this happen?????
  // *************************************
  if (zipCode && latitude && longitude) {
    // DDFIX  - do you want to validate values using regexp
    console.log(
      `CFD_FUNC_LOCA_getLocationFromZipCode INPUT: ` +
        zipCode +
        latitude +
        longitude
    )
    // DDFIX - where is memo coming from
    if (memo.zipCode && memo.zipCode === zipCode) {
      return Promise.resolve(memo.result)
    } else {
      console.log(`CFD_FUNC_LOCA_getLocationFromZipCode: making a result`)

      const result = {
        zipCode,
        latitude,
        longitude,
      }

      memo = { zipCode, result }
      return Promise.resolve(memo.result)
    }
  } // end ' we have a zip code'

  console.log(
    `CFD_FUNC_LOCA_getLocationFromZipCode: *** DOING A LOOKUP ***` + zipCode
  )

  // *************************************
  //  DO THE GOOGLE API Retrieval
  // failure on google is
  //  "results" : [],
  //  "status" : "ZERO_RESULTS"
  // *************************************

  const url = `https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyAus2Lev-1iv9ySqhHJApw68HS4xeOAFGE&address=${zipCode}&sensor=false`
  const options = {
    method: 'GET',
    cors: true, // allow cross-origin HTTP request
    credentials: 'omit',
    cache, // result shouldn't change over time
  }

  ///-------------------------------------------------
  //  RETURNING PROMISE
  ///-------------------------------------------------
  return fetch(url, options) // google doesnt
    .then(r => {
      return r.json()
    })
    .then(r => {
      if (r.status === 'OK') {
        const { lat: latitude, lng: longitude } = r.results[0].geometry.location

        for (var i = 0; i < r.results[0].address_components.length; i++) {
          var addr = r.results[0].address_components[i]

          console.log(
            `CFD_FUNC_LOCA_memo2_Doing a loop` + i + '|||' + addr.types[0]
          )

          if (addr.types[0] == 'country') {
            var countryCode = addr.short_name
            console.log(`CFD_FUNC_LOCA_memo2_country:` + addr.short_name)
          } else if (
            addr.types[0] == 'locality' ||
            addr.types[0] == 'neighborhood'
          ) {
            // ddfixed
            //else if (addr.types[0] == 'locality'  )
            var city = addr.long_name
            console.log(`CFD_FUNC_LOCA_memo2_city:` + addr.long_name)
          } else if (addr.types[0] == 'administrative_area_level_1') {
            var state = addr.short_name
            console.log(`CFD_FUNC_LOCA_memo2_state:` + addr.short_name)
          }
        }

        const address = city + ', ' + state + ' ' + zipCode //r.results[0].formatted_address.replace(/, ?USA$/, '')

        const result = {
          ...location,
          address,
          latitude,
          longitude,
          city,
          state,
          zipCode,
          countryCode,
        }
        memo = { zipCode, result }
        return memo.result
      } else {
        throw new Error('zip code lookup failed')
      }
    })
} //end getLocationFromZipCode

//---------------------------------------
//  DDFIX is this used?
//---------------------------------------
export const getZipCodeFromLocation = (location, cache = gcache) => {
  console.log(`CFD_FUNC_LOCA_getZipCodeFromLocation:`)

  const options = {
    method: 'GET',
    cors: true, // allow cross-origin HTTP request
    credentials: 'omit',
    cache, // result shouldn't change over time
  }

  const { latitude, longitude } = location
  //ddorig  const url = `http://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}` //`&sensor=false`
  const url = `https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyAus2Lev-1iv9ySqhHJApw68HS4xeOAFGE&latlng=${latitude},${longitude}` //`&sensor=false`

  return fetch(url, options)
    .then(res => res.json())
    .then(res => {
      if (res.status === 'OK') {
        let zipCode = null
        res.results[0].address_components.forEach(record => {
          if (record.types.includes('postal_code')) {
            address.zipCode = record.long_name // TODO could store full address
          }
        })
        const { formatted_address: address } = res.results[0]
        return { ...location, address, zipCode }
      } else {
        throw new Error('zip code lookup failed')
      }
    })
} // end getZipCodeFromLocation

//---------------------------------------
// Dec2022 - this version
//  1- removed gcache paramater, need to add
//  2 - takes an ip paramter
//  3 - removed comments
//---------------------------------------
// coords = {"ip":"24.189.107.117","country_code":"US","country_name":"United States","region_code":"CT","region_name":"Connecticut","city":"New Canaan","zip_code":"06840","time_zone":"America/New_York","latitude":41.1625,"longitude":-73.5021,"metro_code":501}
export const getLocationFromIP = inIP => {
  console.log(`CFD_FUNC_LOCA_getLocationFromIP: ` + inIP)
  //  cors: true, // allow cross-origin HTTP request
  const cache = gcache
  console.log(
    `CFD_FUNC_LOCA_getLocationFromIP 0 - before calling get IP` + inIP
  )
  const options = {
    method: 'GET',
    mode: 'cors',
    credentials: 'omit',
    cache, // result shouldn't change over time
  }

  //return fetch(`http://api.ipstack.com/69.120.96.227?access_key=3a3d38d5a6317924a33eaa076af3bf8a&format=1`, options)  // DEC22ZIPFIX - now enrolled
  const myURL = `https://api.ipstack.com/${inIP}?access_key=3a3d38d5a6317924a33eaa076af3bf8a&format=1`

  ///-------------------------------------------------
  //  RETURNING PROMISE
  ///-------------------------------------------------
  return fetch(myURL, options) // DEC22ZIPFIX - now enrolled
    .then(r => r.json()) /// DDFIX... nothing else here??
    .then(coords => {
      // inner then proceess coords
      console.log(
        `CFD_FUNC_LOCA_getLocationFromIP post ipstack fetch E post deliver: ` +
          myURL
      )
      const {
        latitude,
        longitude,
        city,
        region_code: state,
        zip: zipCode, // this was a key bugfix for zip.. had the wrong name - DEC22ZIPFIX
        country_code: countryCode,
        ip,
      } = coords

      console.log(
        `CFD_FUNC_LOCA_getLocationFromIP post ipstack fetch F post deliver:` +
          city
      )
      console.log(
        `CFD_FUNC_LOCA_getLocationFromIP post ipstack fetch F post deliver:` +
          countryCode
      )

      //-------------------------------------------------
      //  FAIL:  Cant figure IP address
      //-------------------------------------------------
      if (coords.success == false) {
        // only available if failure
        //DDFIX . this should be logged on serverside
        console.log(
          `CFD_FUNC_LOCA_getLocationFromIP Failure: ` + coords.error.code
        )
        console.log(
          `CFD_FUNC_LOCA_getLocationFromIP Failure: ` + coords.error.type
        )
        console.log(
          `CFD_FUNC_LOCA_getLocationFromIP Failure: ` + coords.error.info
        )

        return {
          address: `Manville, NJ 08835`,
          addressComponents: {
            city: 'Manville',
            state: 'NJ',
            zipCode: '08835',
          },
          longitude: -74.59026349999999,
          latitude: 40.5448011,
          zipCode: '08835',
          city: 'Manville',
          state: 'NJ',
          countryCode: 'US',
        }
      }
      //-------------------------------------------------
      //  FAIL:  Not US, Make it manville
      //-------------------------------------------------
      if (coords.country_code != 'US') {
        //DDFIX . this should be logged on serverside
        console.log(
          `CFD_FUNC_LOCA_getLocationFromIP NON-US: ` + coords.country_code
        )
        console.log(
          `CFD_FUNC_LOCA_getLocationFromIP NON-US: ` + coords.region_code
        )
        console.log(`CFD_FUNC_LOCA_getLocationFromIP NON-US: ` + coords.city)
        console.log(`CFD_FUNC_LOCA_getLocationFromIP NON-US: ` + coords.zip)
        return {
          address: `Bridgewater, NJ 08807`,
          addressComponents: {
            city: 'Bridgewater',
            state: 'NJ',
            zipCode: '08807',
          },
          latitude: 40.587509,
          longitude: -74.617447,
          zipCode: '08807',
          city: 'Bridgewater',
          state: 'NJ',
          countryCode: 'US',
        }
      }

      return {
        address: `${city}, ${state} ${zipCode}`,
        addressComponents: { city, state, zipCode },
        latitude,
        longitude,
        zipCode,
        city,
        state,
        countryCode,
      }
    }) // inner then proceess coords
    .catch(error => {
      //  this.setState({ errorMessage: error.toString() });
      //  should send alert that this failed to carfinder.
      return {
        address: `Manville, NJ 08835`,
        addressComponents: {
          city: 'Manville',
          state: 'NJ',
          zipCode: '08835',
        },
        longitude: -74.59026349999999,
        latitude: 40.5448011,
        zipCode: '08835',
        city: 'Manville',
        state: 'NJ',
        countryCode: 'US',
      }
    }) //.catch block
} // end getLocationFromIP

//---------------------------------------
//
//---------------------------------------
export const getLocation = (location, maximumAge = 24 * 60 * 60 * 1000) => {
  console.log(`CFD_FUNC_LOCA_getLocation:`)
  const options = {
    enableHighAccuracy: false,
    //timeout: 60 * 1000,
    maximumAge,
  }

  const promise = new Promise((resolve, reject) => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        location => resolve(location),
        err => reject(err),
        options
      )
    } else {
      reject(new Error('Not Supported'))
    }
  })

  // Navigator does not provide zip code, so get this from google
  return promise.then(location => getZipCodeFromLocation(location))
} // end getLocation

//---------------------------------------
//
//---------------------------------------
export const setMyStatePlease = (inName, inValue) => {
  var mystate = JSON.parse(localStorage.getItem('state'))
  //state.setState({[inName]: inValue})
  //state.{inName}=inValue;
  //tempstate.myBasicParams.ipp=23
  localStorage.setItem('state', JSON.stringify(mystate))
}

//---------------------------------------
//
//---------------------------------------
export const getClientIP = () => {
  console.log(`CFD: in get client IP 0 before the fetch 0:`)
  return fetch(`https://geolocation-db.com/json/`) // DEC22ZIPFIX - now enrolled
    .then(r => {
      //  need explict return on any multiline fat arrow
      //console.log(`im in get client IP a:` + r.status )     ;
      //console.log(`im in get client IP b:` +  r.ok )     ;
      //console.log(`im in get client IP  c:` + r.statusText )     ;
      //console.log(`im in get client IP  d:` + r.json.IPv4)     ;
      return r.json()
    })
}

// *************************************
//  DO THE GOOGLE API Retrieval
//  Do we need a whole different Function for this?
//
// *************************************
export const getLiteLocationFromIP = (zipCode, cache = gcache) => {
  // *************************************
  //  Should ALWAYS have a zip
  // *************************************
  if (!zipCode) {
    Promise.reject(new Error('getLiteLocationFromIP: missing location.zipCode'))
  }
  // this version is missing all the memo stuff from the non-lite verison

  console.log(
    `CFD_FUNC_LOCA_getLiteLocationFromIP: *** DOING A LOOKUP ***` + zipCode
  )

  // *************************************
  //  DO THE GOOGLE API Retrieval
  //  "results" : [],
  //  "status" : "ZERO_RESULTS"
  // *************************************
  const url = `https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyAus2Lev-1iv9ySqhHJApw68HS4xeOAFGE&address=${zipCode}&sensor=false`
  console.log(
    `CFD_FUNC_LOCA_getLiteLocationFromIP: *** DOING A LOOKUP ***|||` + url
  )

  const options = {
    method: 'GET',
    cors: true, // allow cross-origin HTTP request
    credentials: 'omit',
    cache, // result shouldn't change over time
  }

  ///-------------------------------------------------
  //  RETURNING PROMISE
  ///-------------------------------------------------
  return fetch(url, options) // google doesnt
    .then(r => {
      return r.json()
    })
    .then(r => {
      if (r.status === 'OK') {
        const { lat: latitude, lng: longitude } = r.results[0].geometry.location

        for (var i = 0; i < r.results[0].address_components.length; i++) {
          var addr = r.results[0].address_components[i]

          console.log(
            `CFD_FUNC_LOCA_memo2_Doing a loop` + i + '|||' + addr.types[0]
          )

          if (addr.types[0] == 'country') {
            var countryCode = addr.short_name
            console.log(`CFD_FUNC_LOCA_memo2_country:` + addr.short_name)
          } else if (
            addr.types[0] == 'locality' ||
            addr.types[0] == 'neighborhood'
          ) {
            // ddfix
            //else if (addr.types[0] == 'locality')
            var city = addr.long_name
            console.log(`CFD_FUNC_LOCA_memo2_city:` + addr.long_name)
          } else if (addr.types[0] == 'administrative_area_level_1') {
            var state = addr.short_name
            console.log(`CFD_FUNC_LOCA_memo2_state:` + addr.short_name)
          }
        }
        console.log(
          `CFD_FUNC_LOCA_getLiteLocationFromIP: *** DOING A LOOKUP **111:`
        )
        //const address = r.results[0].formatted_address.replace(/, ?USA$/, '')
        const address = city + ', ' + state + ' ' + zipCode
        const result = {
          // ...location,
          address,
          latitude,
          longitude,
          city,
          state,
          zipCode,
          countryCode,
        }

        console.log(
          `CFD_FUNC_LOCA_getLiteLocationFromIP: *** DOING A LOOKUP ***140:` +
            city +
            '||' +
            state
        )
        console.log(
          `CFD_FUNC_LOCA_getLiteLocationFromIP: *** DOING A LOOKUP ***222:` +
            zipCode +
            '||' +
            address
        )

        memo = { zipCode, result }
        return memo.result
      } else {
        throw new Error('zip code lookup failed')
      }
    })
}



// WEBPACK FOOTER //
// ./src/utils/location.js